import { useEffect, useState } from 'react'
import React from 'react'
import cert from '../assets/Images/home-secure/certs.png'
// import { useEffect } from 'react';

function Certs() {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>
            <section className='w-100 mt-8 mb-8'>
                <div className='certs-sections d-flex flex-wrap justify-content-center  w-100'>
                    <div className='w-sm-100 w-50 '>
                        <div className='pl-5 pr-2 w-100 divCert text-black'>
                            <h2 className='pb-1 bebas bolde display-5'>YOU ARE IN SAFE HANDS</h2>
                            <p>We leverage our team’s diverse knowledge and strengths to provide advanced solutions to emerging problems.</p>
                            {/* <p>We aim to be a great organization by constantly developing our teams and creating the most engaging work environment</p> */}
                        </div>
                    </div>
                    <div className=''>
                        <img className={'certifications'} src={cert} height="120px" width="auto" alt="" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Certs